export default __webpack_public_path__ + "static/the_result-f403603cdfbe273250f412a4b7a96627.webp";